import { jsx as _jsx } from "react/jsx-runtime";
import { QueryClient, QueryClientProvider, } from "@tanstack/react-query";
import { memo, StrictMode, useEffect, useMemo, useRef, } from "react";
import { usePersistentReducer } from "../../hooks/usePersistentReducer";
import { defaultWalletOptions, WalletContext } from "../../store/context";
import Bootstrap from "../Bootstrap";
export const client = new QueryClient({
    defaultOptions: {
        queries: {
            retry: false,
            suspense: false,
        },
    },
});
export const WalletProvider = ({ options, children, }) => {
    const mergedOptions = useRef({
        ...defaultWalletOptions,
        ...options,
    });
    // Keep ref in sync with options prop.
    useEffect(() => {
        mergedOptions.current = {
            ...defaultWalletOptions,
            ...options,
        };
    }, [options]);
    const [state, dispatch] = usePersistentReducer();
    const memoizedDispatch = useMemo(() => dispatch, [dispatch]);
    const memoizedState = useMemo(() => ({
        ...state,
        options: mergedOptions.current,
    }), [state, mergedOptions.current]);
    return (_jsx(StrictMode, { children: _jsx(QueryClientProvider, { client: client, children: _jsx(WalletContext.Provider, { value: { state: memoizedState, dispatch: memoizedDispatch }, children: _jsx(Bootstrap, { children: children }) }) }) }));
};
export default memo(WalletProvider);
//# sourceMappingURL=WalletProvider.js.map